import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { IntegradorService } from '../../../../services/integrador.service';
import { PainelinsumoService } from '../../../../services/painelinsumo.service';
import { ToastService } from '../../../../services/toast.service';
import { DepositoInsumo } from '../../../../types/DepositoInsumo.type';
import { Empresa } from '../../../../types/Empresa.type';
import { EmpresaPainel } from '../../../../types/EmpresaPainel.type';
import { MaterialDeposito } from '../../../../types/MaterialDeposito.type';

@Component({
  selector: 'app-insumosexcecaoform',
  templateUrl: './insumosexcecaoform.component.html',
  styleUrl: './insumosexcecaoform.component.css',
})
export class InsumosexcecaoformComponent implements OnInit {
  materialDeposito: MaterialDeposito = {} as MaterialDeposito;
  empresas: EmpresaPainel[] = [];
  depositos: DepositoInsumo[] = [];

  empresaSelecionada: EmpresaPainel = {} as EmpresaPainel;
  depositoSelecionado: DepositoInsumo = {} as DepositoInsumo;

  constructor(
    private painelInsumoService: PainelinsumoService,
    private integradorService: IntegradorService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.carregarDados();
  }

  async carregarDados() {
    await this.buscaEmpresas();
    this.buscaMaterial();
  }

  buscaDepositos() {
    this.painelInsumoService
      .getDepositosPorInstancia(this.empresaSelecionada.instancia)
      .subscribe({
        next: (data) => {
          this.depositos = data;
        },
        error: (error) => {
          console.error(error);
          this.toastService.erro('Erro', error.error.message);
        },
      });
  }

  buscaMaterial() {
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    if (id) {
      this.painelInsumoService.getMaterialDeposito(id).subscribe({
        next: (data) => {
          this.materialDeposito = data;

          this.empresaSelecionada = this.materialDeposito.empresa;

          this.buscaDepositos();
          this.depositoSelecionado = this.materialDeposito.deposito;
        },
        error: (error) => {
          console.error(error);
          this.toastService.erro('Erro', error.error.message);
        },
      });
    }
  }

  buscaEmpresas(): Promise<any> {
    return firstValueFrom(
      this.painelInsumoService.getListEmpresasPainel()
    ).then((empresas) => {
      this.empresas = empresas;

      return empresas;
    });
  }

  salvar() {
    // this.materialDeposito.cdMaterialPims = this.materialDeposito.cdMaterialPims?.trim() != '' ? this.materialDeposito.cdMaterialPims : "";
    this.materialDeposito.idEmpresa = this.empresaSelecionada.id;
    this.materialDeposito.idDeposito = this.depositoSelecionado.id;

    console.log(this.materialDeposito)

    if (
      this.materialDeposito.idEmpresa?.trim() &&
      this.materialDeposito.idDeposito?.trim() &&
      this.materialDeposito.cdMaterialPims.toString().trim()
    ) {
      if (this.materialDeposito.id) {
        this.painelInsumoService
          .putMaterialDeposito(this.materialDeposito)
          .subscribe({
            next: () => {
              this.toastService.sucesso(
                'Sucesso',
                'Material atualizado com sucesso'
              );
              this.fecharDialog();
            },
            error: (value) => {
              this.toastService.erro(
                'Erro',
                'Erro ao salvar: ' + value.error.message
              );
            },
          });
      } else {
        this.painelInsumoService
          .postMaterialDeposito(this.materialDeposito)
          .subscribe({
            next: (valor) => {
              this.materialDeposito = valor;
              this.toastService.sucesso(
                'Sucesso',
                'Material salvo com sucesso'
              );
              this.fecharDialog();
            },
            error: (value) => {
              this.toastService.erro(
                'Erro',
                'Erro ao salvar: ' + value.error.message
              );
            },
          });
      }
    }else{
      this.toastService.info("Preenchimento", "Necessário preencher todos os campos")
    }
  }

  buscaEmpresaSelecionada = (empresaErp: string): Empresa | undefined => {
    return this.empresas.find((empresa) => empresa.empresaErp === empresaErp);
  };

  fecharDialog() {
    this.materialDeposito = {} as MaterialDeposito;
    this.location.back();
  }
}
